.detail {
  max-height: 70vh;
  overflow-y: auto;
}

.section {
  margin-top: 16px;
}

.cover {
  width: 120px;
  height: 160px;
  object-fit: cover;
  border-radius: var(--ant-border-radius-sm);
}

.cardsTitle {
  margin: 16px 0 12px;
  font-weight: 500;
  color: var(--ant-color-text);
}

.cardsRow {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.characterCard {
  width: 120px;
  padding: 12px;
  text-align: center;
  background: var(--ant-color-fill-alter);
  border: 1px solid var(--ant-color-border-secondary);
  border-radius: var(--ant-border-radius);
}

.characterCard img,
.avatarPlaceholder {
  width: 64px;
  height: 64px;
  margin: 0 auto 8px;
  object-fit: cover;
  border-radius: 50%;
}

.avatarPlaceholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: var(--ant-color-text-tertiary);
  background: var(--ant-color-fill-secondary);
}

.characterName {
  font-weight: 500;
  color: var(--ant-color-text);
}

.characterRole {
  font-size: 12px;
  color: var(--ant-color-text-secondary);
}

.prompt {
  white-space: pre-wrap;
}

.promptNote {
  padding: 12px;
  margin-top: 12px;
  font-size: 12px;
  color: var(--ant-color-text-secondary);
  background: var(--ant-color-info-bg);
  border-left: 3px solid var(--ant-color-info);
  border-radius: var(--ant-border-radius-sm);
}

.promptCount {
  margin-top: 4px;
  color: var(--ant-color-text-tertiary);
}
